import { Box, Typography, useTheme } from '@mui/material';

import SectionTitle from './SectionTitle';

const contents = [
  'Điều khoản',
  '1. Bệnh nhân đồng ý tuân theo tất cả các nội quy và quy định của bệnh viện cũng như mọi chỉ thị do bất kỳ đại diện nào của bệnh viện đưa ra. Khi bác sĩ, sau khi nhận định, đưa ra bất kỳ\nhình thức xuất viện nào cho bệnh nhân, bệnh nhân phải tuân theo chỉ dẫn của bác sĩ.',
  '2. Bệnh nhân hoặc người bảo lãnh phải thanh toán toàn bộ chi phí y tế cho bệnh viện theo thỏa thuận trước. Nếu bệnh nhân không thanh toán đầy đủ chi phí y tế, bệnh viện sẽ giữ lại\ntoàn bộ tiền đặt cọc mà bệnh nhân hoặc người bảo lãnh đã thanh toán khi nhập viện và sẽ áp dụng biện pháp pháp lý đối với bệnh nhân hoặc người bảo lãnh tại tòa án trong phạm vi\nthẩm quyền của Hàn Quốc.',
  '3. Nếu bệnh nhân không được bảo hiểm y tế Hàn Quốc chi trả, bệnh nhân phải có người bảo lãnh tại Hàn Quốc có đủ nguồn tài chính để bảo trợ cho bệnh nhân hoặc đặt cọc (số tiền $ ...)\ntrở lên theo quy định của bệnh viện, số tiền này sẽ được áp dụng vào tổng chi phí điều trị y tế. Tuy nhiên, bất kỳ khoản tiền nào vượt quá số tiền đặt cọc phải được thanh toán trong thời\nhạn thanh toán mà bệnh viện đã quy định bởi bệnh nhân hoặc người bảo lãnh với trách nhiệm chung.',
  '4. Bệnh nhân và người bảo lãnh chịu trách nhiệm chung trong việc chi trả phí y tế chung (dịch vụ y tế, vật tư y tế, trang thiết bị y tế, vật tư khắc).',
  '5. Bệnh nhân đồng ý chịu trách nhiệm về bất kỳ thiệt hại hoặc tổn thất nào do bệnh nhân trực tiếp hoặc gián tiếp gây ra cho bệnh viện, nhân viên, hoặc tài sản của bệnh viện, và sẽ chịu\ntrách nhiệm tài chính để thay thế hoặc sửa chữa tổn thất hoặc hỏng hóc đó trước khi ra viện.',
  '6. Bệnh viện không chịu trách nhiệm đối với việc mất, hỏng hoặc bị trộm của tài sản cá nhân, vật giá trị, tiền bạc của bệnh nhân hoặc người thân của họ trong khi ở trong bệnh viện.',
  '7. Nếu ở trong phòng đặc biệt khác ngoài phòng thông thường, bệnh nhân sẽ phải chịu phí phụ thu cho thức ăn và phòng, cũng như mọi chi phí bổ sung.',
  '8. Đối với bất kỳ vấn đề nào xảy ra trong hoặc sau khi bệnh nhân nhập viện, phẫu thuật, thủ tục, điều trị hoặc chăm sóc, bệnh nhân không thể kiện bệnh viện ngoại trừ trong trường hợp\ncó lỗi y tế của bệnh viện.',
];

const PatientsRights = () => {
  const { palette } = useTheme();

  return (
    <>
      <SectionTitle title="Khi bạn tới nơi" />
      <Box
        sx={{
          width: '98%',
          margin: '48px auto 10px auto',
        }}
      >
        <Typography
          sx={{
            fontWeight: '400',
            fontSize: '15px',
            lineHeight: '24px',
            whiteSpace: 'pre-wrap',
          }}
        >
          Nếu bạn có bất kỳ câu hỏi nào về tài liệu này hoặc không hiểu bất kỳ
          phần nào của tài liệu này, hoặc cần một thông dịch viên, hãy hỏi bác
          sĩ của bạn hoặc các bác sĩ khác.
        </Typography>
      </Box>

      <Box
        sx={{
          width: '98%',
          margin: '0px auto 10px auto',
          border: '1px solid lightgray',
          padding: '10px',
        }}
      >
        {contents.map((v, i) => {
          if (i === 0) {
            return (
              <Typography
                sx={{
                  fontWeight: '500',
                  fontSize: '15px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '15px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
              }}
            >
              {v}
            </Typography>
          );
        })}
      </Box>

      <Box
        sx={{
          width: '98%',
          margin: '20px auto 20px auto',
        }}
      >
        <Typography
          sx={{
            fontWeight: '500',
            fontSize: '15px',
            lineHeight: '24px',
            whiteSpace: 'pre-wrap',
            color: `${palette.primary.dark}`,
          }}
        >
          Tôi đã đọc và hiểu các điều khoản ở trên.
        </Typography>
      </Box>
    </>
  );
};

export default PatientsRights;
